<template>
  <!-- Marks an assignment whose member cannot actually see the practice.
       Renders nothing when `gap` is null, so callers can bind it unconditionally. -->
  <span
    v-if="gap"
    class="inline-flex items-center align-middle mr-1"
    :class="linkTarget ? 'cursor-pointer' : 'cursor-help'"
    :title="tooltip"
    @click.stop="openIam"
  >
    <svg class="w-3.5 h-3.5" fill="none" stroke="#B45309" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/></svg>
  </span>
</template>

<script>
export default {
  name: 'Worklist_Assignment_GapWarning',
  props: {
    // A gap object from /api/team-assignments/visibility-gaps/, or null.
    gap: { type: Object, default: null },
  },
  computed: {
    // Only no_grant is fixable by editing entity access; a member with no linked
    // login has no IAM page to send anyone to.
    linkTarget() {
      if (!this.gap || !this.gap.user_id) return null;
      return `/admin/user/${this.gap.user_id}`;
    },
    tooltip() {
      if (!this.gap) return '';
      const who = this.gap.member_name || 'This member';
      const where = this.gap.entity_name || 'this practice';
      const suffix = this.linkTarget ? ' Click to open their access settings.' : '';
      if (this.gap.reason === 'no_login') {
        return `${who} has no linked login, so no assignment to them delivers work.`;
      }
      if (this.gap.reason === 'no_access_entities') {
        return `${who}'s login has no entity access at all, so this assignment delivers no work.${suffix}`;
      }
      return `${who}'s login cannot see ${where}. This assignment delivers no work until entity access is granted.${suffix}`;
    },
  },
  methods: {
    openIam() {
      if (this.linkTarget) this.$router.push(this.linkTarget);
    },
  },
};
</script>
